// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/stylesheets/widgets/searchFieldWidget.styl
// module id = 358
// module chunks = 0